import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { TicketDocument } from '~/types/Ticket';

import { DocumentItem } from './DocumentItem';

interface SortableDocumentItemProps {
  id: string;
  document: TicketDocument;
  validationError?: string;
  onRemove?: (ticketId: string) => void;
  canRemove?: boolean;
}

export const SortableDocumentItem = ({
  id,
  document,
  validationError,
  onRemove,
  canRemove,
}: SortableDocumentItemProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <DocumentItem
        document={document}
        ticketId={id}
        isDragging={isDragging}
        validationError={validationError}
        dragHandleProps={listeners}
        onRemove={onRemove}
        canRemove={canRemove}
      />
    </div>
  );
};
